import styled from 'styled-components';
import Button from '@/trio-ui/Button';

export const CustomButton = styled(Button)`
  height: 32px;
  width: 260px;
  justify-content: center;
`;

export const Title = styled.a`
  color: ${(props) => props.theme.colors['primary-60']};
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  display: block;
  padding: 12px 0;
  width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;
